export const getLoadingHtml = (): string => {
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Loading...</title>
        <style>
          body {
            margin: 0;
            padding: 0;
          }

          .spinner-view {
            width: 100vw;
            height: 100vh;
            opacity: 0.75;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            background-color: #ffffff;
          }

          .loader {
            text-align: center;
          }

          .spinner {
            border: 4px solid #ececee;
            border-top: 4px solid #3f98d2;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin 1s linear infinite;
            margin: 0 auto 20px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .text {
            color: #1d252d;
            font-size: 16px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          }
        </style>
      </head>
      <body>
        <div class="spinner-view">
          <div class="loader">
            <div class="spinner"></div>
            <div class="text">Loading...</div>
          </div>
        </div>
      </body>
    </html>
  `;
};
